import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for registered documents table.
 * @extends JetView
 */
export default class tableRegisteredDocumentView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Editar', // Tooltip text
                                    template: function (obj) {
                                        // Template for rendering the column
                                        return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Route', // Column ID
                                    header: _('Ruta'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Version', // Column ID
                                    header: _('Versión'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: '', value: _('Todos') },
                                        { id: 'I', value: _('Documento 1') },
                                        { id: 'R', value: _('Documento 2') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activo') },
                                        { id: 'I', value: _('Inactivo') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit icon click
                                    $$('EditDocument').show(); // Show edit document popup
                                },
                            },
                            ready: function () {
                                // Event handler for when the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show overlay message
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
            on: {
                onItemDblClick: (id) => {
                    // Event handler for double-click on item
                    $$('EditDocument').show(); // Show edit document popup
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        grid = $$('datatable'); // Reference to the datatable
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/RegisteredDocument/GetDocuments?Partner=' + id_partner + '&'; // Base URL for API requests
        var filter = ''; // Filter string for API requests

        this.on(this.app, 'registeredDocument:filter', (filterData) => {
            // Event handler for filter event
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle date filter
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter string
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        grid.attachEvent('onBeforeEditStart', function (id) {
            // Event handler for before edit start
            var item = this.getItem(id); // Get item being edited
            console.log(item); // Log item details
            if (id.column == 'Action') {
                // Check if editing the Action column
                var options = this.getColumnConfig('Action').collection; // Get column options
                if (item.IsRegisterActivate != 'I') {
                    // Check activation status
                    console.log(item); // Log item details
                    return false; // Prevent editing if not inactive
                }
                console.log(id); // Log ID
            }
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });

        // Popup for editing documents
        var popup = webix.ui({
            view: 'window',
            id: 'EditDocument', // ID for the edit document popup
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Documento') }, // Label for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form',
                id: 'editForm', // ID for the edit form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Read-only ID field
                    { view: 'text', label: _('Nombre'), name: 'Name' }, // Name field
                    { view: 'text', label: _('Ruta'), name: 'Route' }, // Route field
                    { view: 'text', label: _('Versión'), name: 'Version' }, // Version field
                    {
                        view: 'combo',
                        label: _('Tipo'), // Type field
                        name: 'Type',
                        options: [
                            // Options for the combo
                            { id: '1', value: _('Documento 1') },
                            { id: '2', value: _('Documento 2') },
                        ],
                    },
                    {
                        view: 'combo',
                        label: _('Estado'), // Status field
                        name: 'IsActivate',
                        options: [
                            // Options for the combo
                            { id: 'A', value: _('Activado') },
                            { id: 'I', value: _('Inactivado') },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on cancel
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'RegisteredDocument/UpdateDocument', // API endpoint for updating document
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "Route":"' +
                                                values.Route +
                                                '", "Version":"' +
                                                values.Version +
                                                '", "Type":"' +
                                                values.Type +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '", "Partner":"' +
                                                id_partner +
                                                '"}', // JSON payload
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        'Documento Actualizado', // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide popup after saving
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Popup for adding documents
        var popupAdd = webix.ui({
            view: 'window',
            id: 'AddDocument', // ID for the add document popup
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Documento') }, // Label for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form',
                id: 'addform', // ID for the add form
                elements: [
                    { view: 'text', label: _('Nombre'), name: 'Name' }, // Name field
                    { view: 'text', label: _('Ruta'), name: 'Route' }, // Route field
                    { view: 'text', label: _('Versión'), name: 'Version' }, // Version field
                    {
                        view: 'combo',
                        label: _('Tipo'), // Type field
                        name: 'Type',
                        options: [
                            // Options for the combo
                            { id: '1', value: _('Documento 1') },
                            { id: '2', value: _('Documento 2') },
                        ],
                    },
                    {
                        view: 'combo',
                        label: _('Estado'), // Status field
                        name: 'IsActivate',
                        options: [
                            // Options for the combo
                            { id: 'A', value: _('Activado') },
                            { id: 'I', value: _('Inactivado') },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'RegisteredDocument/AddDocument', // API endpoint for adding document
                                            '{"Name":"' +
                                                values.Name +
                                                '", "Route":"' +
                                                values.Route +
                                                '", "Version":"' +
                                                values.Version +
                                                '", "Type":"' +
                                                values.Type +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '", "Partner":"' +
                                                id_partner +
                                                '"}', // JSON payload
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        'Documento Agregado', // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide popup after saving
                                },
                            },
                        ],
                    },
                ],
            },
        });

        this.on(this.app, 'addDocument:button', (filter) => {
            // Event handler for add document button
            popupAdd.show(); // Show add document popup
        });

        $$('editForm').bind($$('datatable')); // Bind edit form to datatable
    }
}

// FILE DOCUMENTED
